import { getMe } from '@/modules/auth/api/user.service'
import { useAuthStore } from '@/modules/auth/store/auth.store'
import { usePermissionsStore } from '@/modules/auth/store/permissions.store'

let initializationPromise = null
let refreshPromise = null

function getUserId(user) {
  return user?.id ?? user?.Id ?? null
}

async function performSessionInitialization() {
  const authStore = useAuthStore()
  const permissionsStore = usePermissionsStore()

  try {
    const response = await getMe()
    const currentUser = response.data

    authStore.setUser(currentUser)
    permissionsStore.clearPermissions()
    await permissionsStore.fetchPermissions(true)

    return currentUser
  } catch {
    authStore.clearUser()
    permissionsStore.clearPermissions()
    return null
  }
}

export function initializeSession() {
  if (!initializationPromise) {
    initializationPromise = performSessionInitialization()
  }

  return initializationPromise
}

async function performSessionRefresh() {
  await initializeSession()

  const authStore = useAuthStore()
  const permissionsStore = usePermissionsStore()
  const previousUser = authStore.user

  try {
    const response = await getMe()
    const currentUser = response.data
    const previousUserId = getUserId(previousUser)
    const currentUserId = getUserId(currentUser)
    const identityChanged =
      previousUserId === null ||
      currentUserId === null ||
      String(previousUserId) !== String(currentUserId)

    authStore.setUser(currentUser)

    if (identityChanged) {
      permissionsStore.clearPermissions()
    }

    await permissionsStore.fetchPermissions(true)

    return currentUser
  } catch {
    authStore.clearUser()
    permissionsStore.clearPermissions()
    return null
  }
}

export function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = performSessionRefresh().finally(() => {
      refreshPromise = null
    })
  }

  return refreshPromise
}
